module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_styled_01-71894b6ba1b97950bf685dd1e59f57e6.png";